<template>
  <v-card elevation="0" outlined>
    <div class="d-flex justify-center white lighten-3 pa-5 grey--text">
      {{ $t('emptyState.noData') }}
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'EmptyQuestions'
}
</script>
